<template>
  <div class="page_wrapper container-fluid lecture_area">
    <div class="row page_header private_policy_header">
      <consent-header 
        titleCh="職涯諮詢同意書"
        titleEn="Career Counseling Consent Form"
      />
    </div>
    <div class="row private_policy_details_content">
      <career-consent-content />
    </div>
  </div>
</template>
<script>
import ConsentHeader from '~components/pages/consent/ConsentHeader'
import CareerConsentContent from '~components/pages/consent/CareerConsentContent'
export default {
  name: 'ConsentCareer',
  routerName: 'ConsentCareer',
  components: {
    ConsentHeader,
    CareerConsentContent
  }
}
</script>
